import ILog from '@/models/LogData';
import IErrorLogMsg from '@/models/logging/IErrorLogMsg';
import WebEnvConfig from '@/models/WebEnvConfig';
import ServiceHelperFactory from './ServiceHelperFactory';
import BaseApiService from '../BaseApiService';
import IServiceHelper from './IServiceHelper';

export default class LogService extends BaseApiService {
    constructor(webEnvConfig: WebEnvConfig) {
        super(webEnvConfig.urls?.quickSourceApi ?? '');
    }

    getServiceHelper(): IServiceHelper {
        return ServiceHelperFactory.getHelper();
    }

    async saveUsageLog(payload: ILog): Promise<boolean> {
        this.addContentTypeJsonHeader();
        const result = await this.axiosInstance.post('/v1.0/QuickSourceClientLogging/LogUsageItem', JSON.stringify(payload));
        return result.status === 200;
    }

    async saveErrorLog(payload: IErrorLogMsg): Promise<boolean> {
        this.addContentTypeJsonHeader();
        const result = await this.axiosInstance.post('/v1.0/QuickSourceClientLogging/LogErrorItem', JSON.stringify(payload));
        return result.status === 200;
    }
}
